import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ParticipantService } from 'src/services/participant.service';
import { studyModel } from 'src/models/study.model';
import { map } from 'rxjs/operators';
import { SHARED_IMPORTS } from 'src/app/shared/shared.module';

@Component({
  selector: 'app-lsr-participantstudylist',
  templateUrl: './participant_study_list.component.html',
  styleUrls: ['./participant_study_list.component.css'],
  standalone: true,
  imports: [...SHARED_IMPORTS]
})
export class ParticipantStudyListComponent implements OnInit {

  studyModel: studyModel[];
  studyRequirements = new studyModel;
  requirements: any;
  constructor(private participantService: ParticipantService,private cdr : ChangeDetectorRef) {
  }

  private safeParseJson(value: any): any {
    if (value === null || value === undefined || value === '') {
      return [];
    }

    if (Array.isArray(value) || typeof value === 'object') {
      return value;
    }

    try {
      return JSON.parse(value);
    } catch {
      return [];
    }
  }

  ngOnInit() {
    this.participantService.getStudyList()
      .pipe(
        map(mapvalue => {
          if (mapvalue && mapvalue.length > 0) {
            mapvalue.forEach(element => {
              element.studyRequirements = this.safeParseJson(element.studyRequirements);
              element.studyCommitment = this.safeParseJson(element.studyCommitment);
            });
          }
          return mapvalue;
        })
      )
      .subscribe(resp => {
        this.studyModel = resp;
         this.cdr.detectChanges();
      });
  }

}
